const THRESHOLD_ACTION_ALIASES = new Map<string, string>([['scrub', 'scrubber']]);

export const normalizeThresholdActionKey = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return '';
  const normalized = trimmed.toLowerCase();
  return THRESHOLD_ACTION_ALIASES.get(normalized) ?? normalized;
};

export const normalizeThresholdActionKeys = (values: string[]): string[] =>
  values.map((action) => normalizeThresholdActionKey(action)).filter((action) => action.length > 0);
